import './toast.less';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const ENTERTIME = 300;
const LEAVETIME = 300;
class Toast extends Component{
    constructor(props){
        super(props)
        this.state = {
            show : true
        }
    }
    close(){
        window.setTimeout(() => {
            this.setState({
                show : false
            });
            window.setTimeout(() => {
                this.teardown();
            },LEAVETIME);
        },this.props.timeout);
    }
    teardown(){
        let container = this.props.container;
        ReactDOM.unmountComponentAtNode(container);
        container.parentNode.removeChild(container);
    }
    componentDidMount(){
        this.close();
    }
    render(){
        let {show} = this.state;
        let {text, type} = this.props;
        var toastNode;
        if(show){
            let iconNode;
            // if(type == 'success'){
            //     iconNode = (<i className="icn u-icn-31" />);
            // }
            // else if(type == 'error'){
            //     iconNode = (<i className="u-icn u-icn-32" />);
            // }
            toastNode = (
                <div className="m-sysmsg">
                    <div className="sysmsg" dangerouslySetInnerHTML={{ __html: text }}>
                    </div>
                </div>
            );
        }
        return (
            <ReactCSSTransitionGroup component="div" transitionName="z-transition" transitionEnterTimeout={ENTERTIME} transitionAppear={true} transitionAppearTimeout={ENTERTIME} transitionLeaveTimeout={LEAVETIME}>
                {toastNode}
            </ReactCSSTransitionGroup>
        )
    }
}
Toast.propTypes = {
    container : PropTypes.object.isRequired,
    type : PropTypes.string,
    text : PropTypes.string.isRequired,
    timeout : PropTypes.number
}
Toast.defaultProps = {
    timeout : 2000
}
export default function toast(text, timeout){
    let tempDiv = document.createElement('div');
    document.body.appendChild(tempDiv);
    let data = {};
    if(typeof text == 'string'){
        data['text'] = text;
    }
    else if(typeof text == 'object'){
        data = text;
    }
    let props = {
        container : tempDiv,
        ...data
    }
    if(timeout){
        props.timeout = timeout;
    }
    ReactDOM.render(<Toast {...props} />, tempDiv);
}


// WEBPACK FOOTER //
// ./client/component/message/toast.js